import { camelCase } from "change-case";
import config from "../config";
import { isEmpty, isObject, isArray, isFunction, coerceType } from "./helpers";

export const LOCALSTORAGE_KEY_PREFIX = camelCase(config.id);

function checkItemNameIsSafe(itemName: string): boolean {
  return /^[a-z_-][a-z0-9_-]*$/i.test(itemName);
}

function enforceSafeItemName(itemName: string): void {
  if (!checkItemNameIsSafe(itemName)) {
    throw new Error(
      "Please ensure to use a safe item name, e.g. sweet_cool-itemName123"
    );
  }
}

/**
 * Set a value in the local storage.
 *
 * Objects will be stringified.
 */
export function setStoredItem(itemName: string, value: any) {
  enforceSafeItemName(itemName);

  const itemValue =
    // Stringify objects and arrays
    isObject(value) || isArray(value)
      ? JSON.stringify(value)
      : // Prevent functions, undefined and null values being saved
      !isFunction(value) && !isEmpty(value)
      ? value
      : "";

  return localStorage.setItem(
    `${LOCALSTORAGE_KEY_PREFIX}_${itemName}`,
    itemValue
  );
}

/**
 * Get a value from the local storage.
 *
 * Stringified objects will be unstringified.
 */
export function getStoredItem(itemName: string, defaultValue: any = ""): any {
  let itemValue = localStorage.getItem(
    `${LOCALSTORAGE_KEY_PREFIX}_${itemName}`
  );

  // Attempt to detect and parse JSON
  if (itemValue) {
    try {
      itemValue = JSON.parse(itemValue);
    } catch (error) {}
  }

  return !isEmpty(itemValue) ? coerceType(itemValue) : defaultValue;
}

export function getStoredItemAsIs(
  itemName: string,
  defaultValue: any = ""
): any {
  let itemValue = localStorage.getItem(
    `${LOCALSTORAGE_KEY_PREFIX}_${itemName}`
  );
  return !isEmpty(itemValue) ? itemValue : defaultValue;
}
